'use client'

import { useAction } from 'next-safe-action/hooks'

import { validateEmail as _validateEmail } from '@/entities/auth'
import { useServerErrorHandler } from '@/shared/config/action'

export const useValidateEmail = ({
  onSuccess,
}: {
  onSuccess?: (email: string) => void
} = {}) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(_validateEmail, {
    onSuccess: ({ data }) => {
      if (data?.email) {
        onSuccess?.(data.email)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  const validateEmail = (email: string) => {
    action.execute({ email })
  }

  const validateEmailAsync = async (email: string) => {
    const result = await action.executeAsync({ email })

    if (result?.serverError) {
      return false
    }

    return true
  }

  return { validateEmail, validateEmailAsync }
}
